<template>
  <div>
    <el-card shadow="never">
      <div slot="header" class="header">
        <span>灰度发版</span>
      </div>

      <div class="release-panel" v-loading="loading">
        <div class="state-line" v-if="testPort !== null">
          测试端口：
          <el-tag size="medium">{{ testPort }}</el-tag>
        </div>

        <div class="state-line">
          当前状态：
          <el-tag :type="isGaryVersion ? 'warning' : 'success'" size="medium">
            {{ isGaryVersion ? '灰度中' : '全量上线' }}
          </el-tag>
        </div>

        <div class="btn-group">
          <el-button type="warning" :disabled="isGaryVersion" :loading="saving"
                     @click="handleRelease(true)">灰度发版</el-button>
          <el-button type="success" :disabled="!isGaryVersion" :loading="saving"
                     @click="handleRelease(false)">全量上线</el-button>
        </div>

        <div class="tip">
          灰度发版：仅灰度用户可见新版本；全量上线：所有用户可见新版本。
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
// 和其他页面一样走 $axios：baseURL 是构建时注入的 VUE_APP_API_URL，
// 请求拦截器自动拼 /api 前缀、带登录态，响应拦截器统一处理 errno/报错提示
import axios from 'axios'
import {getHost} from '@/utils'

export default {
  name: 'GrayRelease',
  data() {
    return {
      isGaryVersion: false,
      testPort: null,
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadState()
  },
  methods: {
    loadState() {
      this.loading = true
      this.$axios.post('/version/gray/release/get', {}).then(res => {
        this.isGaryVersion = res.isGaryVersion
      }).finally(() => {
        this.loading = false
      })
    },
    // 灰度：带上 isgray:true 头；全量：不带
    // /test/port 返回的不是标准 {errno, errmsg, data} 结构，过不了 $axios 的响应拦截器，用裸 axios 请求
    testPortRequest(isGary) {
      const config = isGary ? {headers: {isgray: 'true'}} : {}
      return axios.get(`${getHost()}/api/test/port`, config).then(res => {
        this.testPort = res.data.port
      }).catch(() => {
        this.testPort = '请求失败'
      })
    },
    handleRelease(isGary) {
      const action = isGary ? '灰度发版' : '全量上线'
      this.$confirm(`确定执行「${action}」吗？`, '提示', {type: 'warning'})
          .then(() => {
            this.saving = true
            this.$axios.post('/version/gray/release/set', {isGaryVersion: isGary}).then(() => {
              this.isGaryVersion = isGary
              this.$message.success(`${action}成功`)
              return this.testPortRequest(isGary)
            }).finally(() => {
              this.saving = false
            })
          })
          .catch(() => {})
    }
  }
}
</script>

<style scoped>
.release-panel {
  padding: 20px 10px;
}

.state-line {
  font-size: 14px;
  color: #606266;
  margin-bottom: 20px;
}

.btn-group {
  margin-bottom: 15px;
}

.btn-group .el-button {
  width: 140px;
}

.tip {
  color: #909399;
  font-size: 12px;
}
</style>
